import { createSlice } from '@reduxjs/toolkit';
import {
    fetchRemoteCalendars,
    createRemoteCalendar,
    updateRemoteCalendar,
    deleteRemoteCalendar,
} from '../thunks/remoteCalendarThunks.js';

const initialState = {
    loading: false,
    list: [],
    maxPageNumber: 0,
    error: '',
};

const remoteCalendarSlice = createSlice({
    name: 'remoteCalendar',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchRemoteCalendars.fulfilled, (state, action) => {
                state.loading = false;
                Object.assign(state, action.payload);
            })
            .addCase(createRemoteCalendar.fulfilled, (state, action) => {
                state.list.unshift(action.payload);
                state.loading = false;
            })
            .addCase(updateRemoteCalendar.fulfilled, (state, action) => {
                const updatedCalendar = action.payload;
                state.list = state.list.map((c) => (c.id === updatedCalendar.id ? updatedCalendar : c));
                state.loading = false;
            })
            .addCase(deleteRemoteCalendar.fulfilled, (state, action) => {
                state.list = state.list.filter(({ id }) => id !== action.payload);
                state.loading = false;
            })
            .addMatcher(
                (action) =>
                    [
                        fetchRemoteCalendars.pending.type,
                        createRemoteCalendar.pending.type,
                        deleteRemoteCalendar.pending.type,
                        updateRemoteCalendar.pending.type,
                    ].includes(action.type),
                (state) => {
                    state.loading = true;
                    state.error = '';
                },
            )
            .addMatcher(
                (action) =>
                    [
                        fetchRemoteCalendars.rejected.type,
                        createRemoteCalendar.rejected.type,
                        updateRemoteCalendar.rejected.type,
                        deleteRemoteCalendar.rejected.type,
                    ].includes(action.type),
                (state, action) => {
                    state.loading = false;
                    state.error = action.payload || action.error?.message;
                },
            )
            .addDefaultCase((state) => state);
    },
});

export default remoteCalendarSlice.reducer;
